import { constDialogMessage } from "./const";
import { Logger } from "./logger";

/**
 * 検証(チェック処理)関連のユーティリティ
 * */
export module verify {

	/**
	 * 空チェック
	 * @param param {string} チェック対象パラメータ
	 * @return 値が空 or 未定義の場合 true
	 */
	export function isEmpty(param: any) {
		if ("" !== param && (typeof param !== "undefined") && (param !== null) && (param != "undefined")) {
			return false;
		} else {
			return true;
		}
	};

	/**
	 * not 空チェック
	 * @param param {string} チェック対象パラメータ
	 * @return 値が空 or 未定義の場合 false
	 */
	export function isNotEmpty(param: any) {
		return !isEmpty(param);
	};

	/**
	 * 文字列長＝0 チェック
	 * @param param {string} チェック対象パラメータ
	 * @return 値がnull or 未定義の場合 true
	 */
	export function isLengthZero(param: string) {
		if (isNotEmpty(param)) {
			return (param.length === 0) ? true : false;
		}
		else {
			return true
		}
	};

	/**
	 * 文字列長≠0 チェック
	 * @param param {string} チェック対象パラメータ
	 * @return 値がnull or 未定義の場合 false
	 */
	export function isNotLengthZero(param: string) {
		if (isNotEmpty(param)) {
			return (0 < param.length) ? true : false;
		}
		else {
			return false;
		}
	};

    /**
     * 数値 有効値チェック
     * @param target    ：チェック対象
     */
    export function validNumber(target: string) {
        let regExp: RegExp = new RegExp(/^[0-9]+$/);
        const result: boolean = regExp.test(target);
        return result;
    }

    /**
     * 半角文字 有効値チェック
     * @param target    ：チェック対象
     */
    export function validHankakuChar(target: string) {
        return (getStringByte(target) === target.length) ? true : false;
    }

    /**
     * 全角半角混在の文字列長チェック
     * @param target    ：チェック対象
     * @param maxLen    ：入力最大値
     */
    export function validStringLen(target: string, maxLen: number): boolean {

        if ((target || "").length === 0) {
            return true;
        }

        const targetLen: number = getStringByte(target);

        Logger.debug("target[" + target + "] len[" + targetLen + "] maxLen[" + maxLen + "] check[" + (targetLen <= maxLen) + "]");

        return (targetLen <= maxLen) ? true : false;
    }

    /**
     * スペースだけテキストのチェック
     * @param target    ：チェック対象
     */
    export function validSpaceAll(target: string[]): boolean {

        if (target.length === 0) {
            return false;
        }

        // 置換して文字が残っていればOK
        let rt = false;
        target.forEach(function (txt: string) {
            const trimStr = txt.replace(/( )/g, "").replace(/(　)/g, "");
            if (trimStr.length > 0) {
                rt = true;
            }
        });
        return rt;
    }

    /**
     * フォントサイズの有効値チェック
     * @param fontSize  ：検証対象
     * @param msgList   ：メッセージリスト
     */
    export function validFontSize(fontSize: string, msgList: string[]): boolean {

        let result: boolean = true;

        // 文字サイズ
        if (fontSize.length == 0) {
            msgList.push(constDialogMessage.WARN_EDIT_INPUT_CHECK_FONTSIZE);
            result = false;
        }
        else {
            let fontSizeReg: RegExp = new RegExp("^([1-9][0-9]{0,}|0)(\.[0-9]{0,2})?$", "g");
            if (!fontSizeReg.test(fontSize)) {
                msgList.push(constDialogMessage.WARN_EDIT_FORMAT_CHECK_FONTSIZE);
                Logger.warn("fontSize[" + fontSize + "]");
                result = false;
            }
        }

        return result;
    }

    /**
     * 対象文字列のバイト数取得
     * @param target    ：対象文字列
     */
    function getStringByte(target: string): number {

        var length = 0;

        for (var i = 0; i < target.length; i++) {
            var c = target.charCodeAt(i);
            if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
                // 半角
                length += 1;
            } else {
                // 全角
                length += 2;
            }
        }

        return length;
    };


}